<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal" type="button">Chiudi</button>
		</p>
		<div>

			<div class="col-sm-12 coldx">
				<h3 class="title1level" style="margin-bottom: 20px;">{{isCopiaFascicolo ? 'Copia fascicolo' : 'Aggiungi fascicolo'}}</h3>

				<div class="container_filtri">
					<div class="filtri" *ngFor="let categoriaTipoFascicolo of listaFascicoliPerCategoria">
						<p>{{categoriaTipoFascicolo.categoria.label}}:</p>
						<ul>
							<ng-template ngFor let-tipoFascicolo [ngForOf]="categoriaTipoFascicolo.tipiFascicolo">
								<li *ngIf="!isCopiaFascicolo"><a [attr.data-dismiss]="'modal'" routerLink="{{getPathFascicoloFromIdTipo(tipoFascicolo.id)}}" title="Vai a Fascicolo {{tipoFascicolo.label | titleAmianto}}" style="text-transform: uppercase">{{tipoFascicolo.label | titleAmianto}}</a></li>
								<li *ngIf="isCopiaFascicolo"><a [attr.data-dismiss]="'modal'" routerLink="{{getPathFascicoloFromIdTipo(tipoFascicolo.id)}}" [queryParams]="{idFascicoloOrigine: fascicoloOrigine.id}" title="Vai a Fascicolo {{tipoFascicolo.label | titleAmianto}}" style="text-transform: uppercase">{{tipoFascicolo.label | titleAmianto}}</a></li>
							</ng-template>
						</ul>
					</div>
				</div>

			</div>

		</div>
	</div>
</div>
